module.exports = __webpack_public_path__ + "img/icon-upcoming-meet.af7cd154.svg";